const bank = process.env.BANK

const componentConfig = {
  pciPrivacyInfo: {
    isVisible: () => {
      const supportedBanks = ['NEXIBUSINESS']
      return supportedBanks.includes(bank)
    }
  }
}

export default componentConfig
